<template>
    <div>
    <DataTable ref="po"
      :value="employeeGroupLists"
      :paginator="true"
      :rows="10"  :filters="filters"
      class="p-datatable-responsive-demo p-datatable-gridlines">
      <Column header="S.n" >
      <template #body="slotProps">
        {{slotProps.index+1}}
      </template>
      </Column>
      <Column
        header="Name" :sortable="true"
        field="value"
        filterMatchMode="contains"
      >
       <template #filter>
            <InputText type="text" class="p-column-filter" v-model="filters['name']" />
        </template>
      </Column>

       <Column header="Action">
      <template #body="slotProps">
        <!-- Edit Button -->
        <Button icon="pi pi-pencil" class="p-button-raised p-button-success"
                @click="editEmployeeGroup(slotProps.data)" />
        <Button class="p-button-raised p-button-danger"
                @click="openDeleteDialog(slotProps.data.id)" icon="pi pi-trash"/>
      </template>
    </Column>

    </DataTable>
  <!-- <Dialog v-model="dialogShow" @cancel="cancel" @deleted="deleteEmployeeGroup"/> -->
   <DeleteDialog v-model="deleteDialog" @cancel="cancelDelete" @deleted="deleteEmployeeGroup"/>
  </div>
</template>
<script>
import DataTable from 'primevue/datatable'
import Column from 'primevue/column'
import Dialog from '../../../layout/dialog'
import InputText from 'primevue/inputtext'
import Button from 'primevue/button'
export default {
  name: 'employeeGroupList',
  data () {
    return {
      dialogShow: false,
      deleteDialog: false,
      accountId: '',
      columnList: '',
      filters: {}
    }
  },
  components: {
    DataTable,
    Column,
    Dialog,
    InputText,
    Button
  },
  computed: {
    employeeGroupLists() {
      return this.$store.state.hr.employeeGroupLists
    }
  },
  mounted() {
    this.employeeGroupList()
    this.columnNames()
  },
  methods: {
    async employeeGroupList() {
      try {
        await this.$store.dispatch('loadHrMasterSetupList', 'EmployeeGroup')
      } catch (e) {}
    },
    async deleteEmployeeGroup(value) {
      if (value.trim() === '') {
        this.$toast.add({severity: 'error', summary: '', detail: 'Delete Reason cannot be empty!!', life: 3000})
        this.deleteDialog = true
        return
      }
      let deleteEmployeeGroup = {
        id: this.id,
        deleteReason: value,
        type: 'EmployeeGroup'
      }
      try {
        let response = await this.$store.dispatch('deleteHrMasterSetup', deleteEmployeeGroup)
        if (response.data.status === 'SUCCESS') {
          this.$toast.add({severity: 'success', summary: '', detail: 'Employee Group ' + response.data.message, life: 3000})
          this.deleteDialog = false
        }
      } catch (e) {
        this.$toast.add({severity: 'warn', summary: '', detail: 'Something went wrong!!', life: 3000})
        return
      }
    },
    columnNames() {
      for (let i = 0; i < this.$refs.po.columns.length; i++) {
        this.columnList += this.$refs.po.columns[i].header + ','
      }
    },
    cancel(data) {
      this.dialogShow = false
    },
    openDialog(id) {
      this.dialogShow = true
      this.accountId = id
    },
    closeDialog() {
      this.dialogShow = false
    },
    editEmployeeGroup(data) {
      this.$emit('edit-employeegroup', data)
    },
    cancelDelete(data) {
      this.deleteDialog = false
    },
    openDeleteDialog(id) {
      this.accountId = id
      this.deleteDialog = true
    }
  }
}
</script>

<style>

</style>



// WEBPACK FOOTER //
// employeeGroupList.vue?ff21cf18